export default (state= "", action: { type: string, payload: string }) => {
  switch (action.type) {
    case "SEARCH_TERM":
      return action.payload;
    default:
      return state;
  }
}
